import * as ActionTypes from '../actions/actionTypes';

const initialState = {
  show_history: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_TIMELINE_HISTORY:
    case ActionTypes.TOGGLE_GRAPHS_HISTORY:
      return { ...state, show_history: !state.show_history };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/timeline.js